import useDeleteData from '../../../hooks/deleteHook';

export const useDeleteUserImage = () => {
  const [{ isCompleted, isLoading, isError, error }, doDelete] =
    useDeleteData('user_profile/image');

  return { isCompleted, isLoading, isError, error, doDelete };
};
